import CandidateInterviewHeader, {
  CandidateInterviewHeaderProps,
} from './CandidateInterviewHeader.component';

export type CandidateInterviewHeaderType = CandidateInterviewHeaderProps;

export default CandidateInterviewHeader;
